import * as React from 'react';

type Props = {
    onUpload?: (files: File[]) => void;
    accepts?: string[];
    getRef?: (ref?: HTMLInputElement | null | undefined) => void;
    allowMultiple?: boolean;
};

export function FileUploadInput(props: Props) {
    const {getRef, allowMultiple = false} = props;

    const fileInputRef = React.useRef<HTMLInputElement | null | undefined>(null);

    // Expose ref to parent component
    React.useEffect(() => {
        if (getRef && fileInputRef.current) {
            getRef(fileInputRef.current);
        }
    }, [getRef]);

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        let files = event.target.files;
        if (!files || files.length === 0) {
            return;
        }

        // @ts-expect-error
        files = Array.from(files);
        // @ts-expect-error
        if (props.onUpload && files.length > 0) {
            // @ts-expect-error
            if (allowMultiple && files.length > 1) {
                // @ts-expect-error
                props.onUpload(files);
            } else {
                // @ts-expect-error
                props.onUpload([files[0]]);
            }
        }

        // Reset the input to allow re-uploading
        event.target.value = '';
    };

    const acceptString =
        props.accepts && props.accepts.length > 0 ? props.accepts.join(',') : undefined;

    return (
        <input
            // @ts-expect-error
            ref={fileInputRef}
            type='file'
            accept={acceptString}
            multiple={allowMultiple}
            className='display-none'
            onChange={handleFileChange}
        />
    );
}
